import { NavigateWithThread, FocusDashboard, Profile, TopSkillDetailPage } from '@yeshuman/sdk'
import { Routes, Route } from 'react-router-dom'
import { ApplicationDetailPage } from '../../../components/candidate/application-detail-page'
import { CandidateJobsPage } from '../../../components/candidate/candidate-jobs-page'
import { CandidateEvaluationAnalysisRoute } from '../../../components/candidate/candidate-evaluation-analysis-route'
import { CandidateOpportunityMatchPage } from '../../../components/candidate/candidate-opportunity-match-page'
import { CandidateJobDetailPage } from '../../../components/candidate/candidate-job-detail-page'
import { CandidateMarketplaceJobDetailPage } from '../../../components/candidate/candidate-marketplace-job-detail-page'
import { CandidateOrganisationPage } from '../../../components/candidate/candidate-organisation-page'
import { CandidatePrivacyPage } from '../../../components/candidate/candidate-privacy-page'

interface CandidateRoutesProps {
  onStartConversation?: (message: string) => void
}

export function CandidateRoutes({ onStartConversation }: CandidateRoutesProps) {
  return (
    <Routes>
      <Route
        index
        element={
          <FocusDashboard
            focus="candidate"
            onStartConversation={onStartConversation}
          />
        }
      />
      <Route path="profile/top-skills/:skillId" element={<TopSkillDetailPage />} />
      <Route path="profile" element={<Profile />} />
      <Route path="jobs/matches/:evaluationId" element={<CandidateOpportunityMatchPage />} />
      <Route path="jobs/analysis/:evaluationId" element={<CandidateEvaluationAnalysisRoute />} />
      <Route path="jobs/marketplace/:id" element={<CandidateMarketplaceJobDetailPage />} />
      <Route path="jobs/:slug" element={<CandidateJobDetailPage />} />
      <Route path="jobs" element={<CandidateJobsPage />} />
      <Route path="organisations/:slug" element={<CandidateOrganisationPage />} />
      <Route path="privacy" element={<CandidatePrivacyPage />} />
      <Route path="applications/:applicationId" element={<ApplicationDetailPage />} />
      <Route path="applications" element={<NavigateWithThread to="/candidate/jobs?tab=applied" />} />
      <Route path="*" element={<NavigateWithThread to="" />} />
    </Routes>
  )
}
